import _ from 'underscore';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { getBulkApiErrors, getODataErrors } from '@bingads-webui-campaign/api-errors';

const getUnexpectedError = i18n => ([{
  message: i18n.getString(_TL_("We've encountered an error and could not finish this task. Please try again or contact support.")),
}]);

export const getBulkEditResponseErrors = (response, i18n, scenario) => {
  if (!response || !response.errors) {
    return getUnexpectedError(i18n);
  }

  const errors = getBulkApiErrors(response.errors, scenario, i18n);

  if (!errors || !errors[0] || !errors[0].message) {
    return getUnexpectedError(i18n);
  }

  // error is a api error class
  return _.map(errors, error => ({ message: error.message }));
};

export const getOdataResponseErrors = (response, i18n) => {
  if (!response || !response.errors) {
    return getUnexpectedError(i18n);
  }

  const errors = getODataErrors(response.errors, i18n);

  if (!errors || !errors[0] || !errors[0].message) {
    return getUnexpectedError(i18n);
  }

  // error is a api error class
  return _.map(errors, error => ({ message: error.message }));
};

// we need this for some edit function without editor, like status change
export const showErrorWithAlertCenter = (response, i18n) => {
  const serverErrors = getBulkEditResponseErrors(response, i18n);
  const error = serverErrors.length && serverErrors[0] && serverErrors[0].message;
  // use alert center to show status ;change error
  if (error) {
    notificationApi.showWarning(error);
  }
};
